
import React, { useEffect, useState } from "react";
import HeaderSession from "../../../../utils/headerSession";
import { Container, Grid } from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import api from "../../../../services/api";
import RegisterAccess from "../../../../utils/registerAccess";
import { makeStyles } from "@material-ui/core";
import NavLateral from "./navLateral";
import { useDispatch, useSelector } from "react-redux";
import { temPermissao } from "../../../../utils/permissoes";
import ProcessoLoading from "../../../../load/processoLoading";


const useStyles = makeStyles((theme) => ({
    grid1: {
        width: 300,
        marginBottom: 15,
        marginLeft: 'auto',
        marginRight: 'auto',

        [theme.breakpoints.up('md')]: {
            // width: '100%',
            height: '100%',
            position: 'sticky',
            top: 70,
        },
    },
    grid2: {
        flexGrow: 1,
        marginLeft: 15,
        // minHeight: '100vh',
        width: 500,
        zIndex: 1,
        // position: 'relative',
    }
}))

export default function GestSolicitacaoImportacaoExportacao({ element: component, ...rest }) {
    const alert = useSelector(state => state.alert.data);
    const user = useSelector((state) => state.account.user);
    const { id } = useParams()
    const [searchParams] = useSearchParams();
    const update = searchParams.get("update");
    const classes = useStyles()
    const [solicitacaoImportacao, setSolicitacao] = useState('')
    const [estabelecimento, setEstabelecimento] = useState('')
    const [refresh, setRefresh] = useState(update)
    const [habiliteThis, setHabiliteThis] = useState(false)
    const [observacoesFeitas, setobservacoesFeitas] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        // !alert && setEstabelecimento(null);

        api.get(`/solicitacao-importacao/${id}`)
            .then(response => {
                // console.log(response);
                setSolicitacao(response.data.solicitacaoImportacao);
                setEstabelecimento(response.data.solicitacaoImportacao.importador);

                api.get(`/observacaos?estabelecimentoId=${response.data.solicitacaoImportacao.importador._id}`)
                    .then((response) => {
                        setobservacoesFeitas(response.data.observacaos);
                    })
                    .catch((err) => "");

            }).catch(err => 'console.log(err)')


        if ((!solicitacaoImportacao?.declaracao && temPermissao(user, ['secçãoImportação'])) || (solicitacaoImportacao?.declaracao && temPermissao(user, ['secçãoCertificadoProdutoControlo']))) {
        }
        else {
            dispatch({
                type: "alert",
                payload: { alert: "Acesso negado" },
            });
            navigate("/admin/menu");
        }
    }, [id, refresh, alert])


    return (
        (estabelecimento && observacoesFeitas) ?
            <Container>
                <RegisterAccess page={'gestão de solicitacao de importação'} />
                <HeaderSession
                    title={solicitacaoImportacao?.declaracao ? 'GESTÃO DE SOLICITAÇĀO DE DESALFANDEGAMENTO' : solicitacaoImportacao?.solicitacaoArea === "Controlados" ? 'SOLICITAÇÃO DE CERTIFICADO PARA PRODUTO CONTROLADO' : 'SOLICITAÇÃO DE IMPORTAÇÃO'} />

                <Grid container>
                    <Grid item className={classes.grid1} m>
                        <NavLateral
                            stabelecimento={solicitacaoImportacao?.importador}
                            solicitacaoImportacao={solicitacaoImportacao}
                            setHabiliteThis={setHabiliteThis}
                            observacoesFeitas={observacoesFeitas}
                        />
                    </Grid>

                    <Grid xs item className={classes.grid2} m>
                        {React.cloneElement(component, {
                            estabelecimento: estabelecimento,
                            solicitacaoImportacao: solicitacaoImportacao,
                            setRefresh: setRefresh,
                            habiliteThis: habiliteThis,
                            setHabiliteThis: setHabiliteThis
                        })}
                    </Grid>
                </Grid>
            </Container>
            :
            <ProcessoLoading />
    )
}